export default __webpack_public_path__ + "static/media/bi.acb03310.svg";